'use client';

import { useAuth } from '@/hooks/useAuth';
import { Header } from '@/components/dashboard/Header';
import { Sidebar } from '@/components/dashboard/Sidebar';
import { StaticPageHeader } from './StaticPageHeader';
import { StaticPageFooter } from './StaticPageFooter';
import { usePathname } from 'next/navigation';

interface AuthAwareLayoutProps {
  children: React.ReactNode;
}

const staticPages = [
  '/about',
  '/features',
  '/pricing',
  '/faq',
  '/contact',
  '/terms',
  '/privacy',
];

export function AuthAwareLayout({ children }: AuthAwareLayoutProps) {
  const { isAuthenticated } = useAuth();
  const pathname = usePathname();
  const isStaticPage = staticPages.includes(pathname);

  if (!isAuthenticated || isStaticPage) {
    return (
      <div className="flex min-h-screen flex-col">
        <StaticPageHeader />
        <div className="flex-1">{children}</div>
        <StaticPageFooter />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <Header />
      <div className="flex min-h-[calc(100vh-4rem)]">
        <Sidebar />
        <main className="flex-1 overflow-x-hidden p-2 md:p-4">
          <div className="max-w-8xl mx-auto">{children}</div>
        </main>
      </div>
    </div>
  );
}
